export type { CreateNewProjectProps } from './create-new-project';
export * from './create-new-project.routes';

export { default as CreateNewProject, default } from './create-new-project';
